let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("k7wxq")).then(() => parcelRequire('82gce'));